import { Topic } from '@common/entities';
import { WhereFilter } from '@common/filter.decorator';
import { TopicFilterForm } from 'src/app/@shared/form/form.types';

type TopicFilterData = Partial<TopicFilterForm>;
const ARRAY_FIELDS: (keyof TopicFilterData)[] = ['sector', 'area', 'domain', 'icdArea', 'icdGroup'];
const CODE_FIELDS: (keyof TopicFilterData)[] = ['icd10Codes', 'icd11Codes'];

export function getTopicWhereFilter(data: TopicFilterData): WhereFilter<Topic> {
  const where: WhereFilter<Topic> = {};
  const rareDisease = data.isRareDisease as boolean | string | undefined;
  if (rareDisease !== undefined && rareDisease !== null && rareDisease !== '') {
    where.isRareDisease = rareDisease === true || rareDisease === 'true';
  }
  for (const field of ARRAY_FIELDS) {
    const values = data[field];
    if (Array.isArray(values) && values.length) {
      where[field] = { contains: values } as any;
    }
  }
  for (const field of CODE_FIELDS) {
    const value = data[field];
    if (typeof value === 'string' && value.trim()) {
      where[field] = { search: value.trim() } as any;
    }
  }
  return where;
}

export function getTopicFilterData(where: WhereFilter<Topic> = {}): TopicFilterData {
  const data: TopicFilterData = {};
  if (typeof where.isRareDisease === 'boolean') {
    data.isRareDisease = String(where.isRareDisease) as any;
  }
  for (const field of ARRAY_FIELDS) {
    const contains = (where[field] as { contains?: unknown[] })?.contains;
    if (Array.isArray(contains)) {
      (data as any)[field] = contains;
    }
  }
  for (const field of CODE_FIELDS) {
    const search = (where[field] as { search?: string })?.search;
    if (search) {
      (data as any)[field] = search;
    }
  }
  return data;
}
